import React from "react";

import "./Contact.css";
function Contact() {
  return (
    <div className="contact_main cursor ">
      <div className="color-white f-1-2 f-500"> HGS</div>
      <div className=" mt-4">
        <div className="d-flex  gap-3 mt-3 overflow-wrap-anywhere">
          <div>
             <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 21s7-6.2 7-12a7 7 0 1 0-14 0c0 5.8 7 12 7 12z" stroke="white" stroke-width="2" />
              <circle cx="12" cy="9" r="2.5" stroke="white" stroke-width="2" />
            </svg>
          </div>
          <div className="color-white f-1">
            (A Co Educational Day School)                         
           ANANGPUR, FARIDABAD – 121003, Haryana
          </div>
        </div>
        <div className="d-flex  gap-3 mt-3 overflow-wrap-anywhere">
          <div>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="3" y="5" width="18" height="14" rx="2" stroke="white" stroke-width="2" />
              <path d="M4 7l8 6 8-6" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </div>
          <div className="color-white f-1">
          principal.anangpurhgs@hgedu.org
          </div>
        </div>
        <div className="d-flex  gap-3 mt-3 overflow-wrap-anywhere">
          <div>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="6" y="2" width="12" height="20" rx="3" stroke="white" stroke-width="2" />
              <line x1="9" y1="5" x2="15" y2="5" stroke="white" stroke-width="2" stroke-linecap="round" />
              <circle cx="12" cy="18" r="1.2" fill="white" />
            </svg>
          </div>
          <div className="color-white f-1">+91-9899786561</div>
        </div>
      </div>
    </div>
  );
}

export default Contact;
